/**
 * Shared helpers for blog cards loaded by Contentful metadata tags (Search idle spotlight, Search typing recommended).
 */

export const SEARCH_SPOTLIGHT_BLOG_LIMIT = 2;

/**
 * @param {object} blog - Blog from mainRegionCollection
 * @returns {string|null}
 */
export function getIdleBlogImageUrl(blog) {
  const headerUrl = blog?.blogHeaderMedia?.url;

  if (headerUrl) {
    return headerUrl;
  }

  const tile = blog?.blogTileImage;

  if (!tile || typeof tile !== 'object') {
    return null;
  }

  if (tile.__typename === 'ShopTheLook') {
    return tile.imageUrl || null;
  }

  return (
    tile.desktopAsset?.url ||
    tile.tabletAsset?.url ||
    tile.mobileAsset?.url ||
    tile.url ||
    null
  );
}

/**
 * @param {object} page - Contentful Page from GetBlogListingPages
 * @returns {object|null}
 */
export function mapPageToSpotlightBlog(page) {
  const blogEntry = page?.mainRegionCollection?.items?.find(
    (item) => item?.__typename === 'Blog'
  );

  if (!blogEntry) {
    return null;
  }

  const slug = String(page?.slug || '').trim();
  const pageSlug = slug.startsWith('/') ? slug : (slug ? `/${slug}` : '');

  return {
    ...blogEntry,
    pageSlug,
    pageTitle: page.title,
    pageSysId: page?.sys?.id,
  };
}
